import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const CurrentActivity = ({ currentTrack, estimatedTimeRemaining, status }) => {
  const getStatusIcon = () => {
    switch (status) {
      case 'searching':
        return 'Search';
      case 'matching':
        return 'Zap';
      case 'adding':
        return 'Plus';
      case 'completed':
        return 'Check';
      case 'failed':
        return 'X';
      default:
        return 'Music';
    }
  };

  const getStatusColor = () => {
    switch (status) {
      case 'searching':
        return 'text-warning';
      case 'matching':
        return 'text-primary';
      case 'adding':
        return 'text-accent';
      case 'completed':
        return 'text-success';
      case 'failed':
        return 'text-error';
      default:
        return 'text-text-secondary';
    }
  };

  const getStatusText = () => {
    switch (status) {
      case 'searching':
        return 'Searching for match...';
      case 'matching':
        return 'Analyzing match quality...';
      case 'adding':
        return 'Adding to playlist...';
      case 'completed':
        return 'Successfully added';
      case 'failed':
        return 'Match failed';
      default:
        return 'Processing...';
    }
  };

  return (
    <div className="bg-surface border border-border rounded-lg p-4 lg:p-6">
      <div className="flex items-center space-x-2 mb-4">
        <div className={`p-2 rounded-lg bg-surface-secondary ${getStatusColor()}`}>
          <Icon 
            name={getStatusIcon()} 
            size={20} 
            className={`${getStatusColor()} ${status === 'searching' || status === 'matching' ? 'animate-pulse' : ''}`}
          />
        </div>
        <div>
          <h3 className="text-lg font-medium text-text-primary">Current Track</h3>
          <p className={`text-sm ${getStatusColor()}`}>{getStatusText()}</p>
        </div>
      </div>

      {currentTrack && (
        <div className="flex items-center space-x-4">
          <div className="flex-shrink-0">
            <Image
              src={currentTrack.albumArt}
              alt={`${currentTrack.title} album art`}
              className="w-16 h-16 lg:w-20 lg:h-20 rounded-lg object-cover"
            />
          </div>
          
          <div className="flex-1 min-w-0">
            <h4 className="text-base lg:text-lg font-medium text-text-primary truncate">
              {currentTrack.title}
            </h4>
            <p className="text-sm text-text-secondary truncate">
              {currentTrack.artist}
            </p>
            <p className="text-xs text-text-muted mt-1">
              {currentTrack.album} • {currentTrack.duration}
            </p>
          </div>
        </div>
      )}

      {estimatedTimeRemaining && (
        <div className="mt-4 pt-4 border-t border-border">
          <div className="flex items-center justify-between text-sm">
            <span className="text-text-secondary">Estimated time remaining:</span>
            <span className="text-text-primary font-medium">{estimatedTimeRemaining}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default CurrentActivity;